module["exports"] = [
  "#{street_name} #{building_number}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/tr/address/street_address.js
 ** module id = 1026
 ** module chunks = 0
 **/